import './styles.scss'
import React, { useState, useEffect, Fragment } from 'react'
import { useLocation } from 'react-router-dom'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { company, EcommerceAPI } from '../../../../api'

import NxCredentialsRow from './NxCredentialsRow'
import Nixi1Loading from '../../../../components/Nixi1Loading'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { connect, useDispatch } from 'react-redux'
import { HandbookIcon } from 'components/common'
import CreatedEcommerceModal from './CreatedEcommerceModal'
import ErrorEcommerceModal from './ErrorEcommerceModal'
import PaymentLinkExpire from './PaymentLinkExpire'
import TemporaryRecord from 'redux/temporaryRecord/actions'

const { credentials: credentialsApi } = company

const CredentialsManagement = (props) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)
  const [credentials, setCredentials] = useState({})
  const [loading, setLoading] = useState(true)
  const [activeKey, setActiveKey] = useState('')
  const [isOkEcommerce, setIsOkEcommerce] = useState(false)
  const [isInvalidCredential, setIsInvalidCredential] = useState(false)

  const handlerGerCredentialsInfo = () => {
    credentialsApi
      .getCredentials()
      .then(({ data, status }) => {
        if (status === 200) {
          setCredentials(data.results)
          queryControl()
        }
      })
      .catch((err) => console.error('error', err))
      .finally(() => {
        setLoading(false)
      })
  }

  const replaceURL = () => window.location.href = '/#/dashboard/configurations/credentials'

  const finishCreatingEcommerce = () => {
    setIsOkEcommerce(false)
    setIsInvalidCredential(false)
    replaceURL()
  }

  const queryControl = async () => {
    const { search } = location
    const query = new URLSearchParams(search)

    const flow = query.get('process')
    const isOkEcommerce = query.get('isOkEcommerce')
    const scrollToActive = query.get('activeKey')

    if (flow && flow === 'install') {
      // Response to redirect from dashboard_back
      replaceURL()
      const credentialEcommerce = dispatch(TemporaryRecord.getByKey('pluginEcommerce'))
      if (!credentialEcommerce) return

      const { data: { credential } } = await credentialsApi.createCredentials(credentialEcommerce)
      await EcommerceAPI.pluginEcommerceActivation({
        shopType: 'shopify',
        data: query.toString(),
        credential: credential._id
      })

      const { data } = await credentialsApi.getCredentials()

      dispatch(TemporaryRecord.remove())
      setCredentials(data.results)
      setIsOkEcommerce(true)
    }

    if (isOkEcommerce) {
      if (isOkEcommerce === 'true') setIsOkEcommerce(true)
      else setIsInvalidCredential(true)
    }

    if (scrollToActive) {
      setActiveKey(scrollToActive)
      const credential = document.getElementById(scrollToActive)
      credential.scrollIntoView()
    }
  }

  useEffect(() => handlerGerCredentialsInfo(), [])

  const toggleModal = () => setShowModal((prevState) => !prevState)

  return (
    <div className='animated fadeIn'>
      <Container className='py-5 company-management credentials-management' fluid>
        <h1>
          {I18n.t('dashboard_credentials')}
          <i className='fa fa-info-circle ml-1' onClick={toggleModal} hidden={props.company.type === 'OP'} />
        </h1>
        {loading ? (
          <Nixi1Loading />
        ) : (
          Object.keys(credentials).map((type) => (
            <div className='section mb-4' key={type}>
              <div className='section-subtitle mb-3' id={type}>{type === 'ecommerce' ? I18n.t('dashboard_ecommerce') : I18n.t(`dashboard_credentials-${type}`)}</div>
              {
                type === 'payment' && (
                  <PaymentLinkExpire />
                )
              }
              <table className='nx-table'>
                <thead>
                  <tr>
                    <th>{I18n.t('dashboard_provider')}</th>
                    <th colSpan={4}>
                      <span className={'pull-right mx-1'}>{I18n.t('dashboard_state')}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {credentials[type].map(({ key, type, enabled, disabled, handbook, translatedProvider, value }, index) => (
                    <Fragment key={index}>
                      <tr onClick={() => setActiveKey(key !== activeKey ? key : '')} id={key}>
                        <td className='d-flex align-items-center provider-title'>
                          <div className='provider-image'>
                            <img src={`/img/logos/${key}.png`} alt={key} />
                          </div>
                          <span className='provider-name'>{translatedProvider ? I18n.t(translatedProvider) : I18n.t(`dashboard_providers-${key}`)}</span>

                          <HandbookIcon url={handbook} />
                        </td>

                        <td className={'px-2'}>
                          <div className={'pull-right'}>
                            <h4 className={'d-inline mx-1'}>
                              <span
                                className='badge badge-pill border-radius count-enabled'
                                title={I18n.t('dashboard_credentials-enabled')}
                                data-toggle='tooltip'
                                data-placement='top'
                              >
                                {enabled}
                              </span>
                            </h4>
                            <h4 className={'d-inline mx-1'}>
                              <span
                                className='badge badge-pill border-radius count-disabled'
                                title={I18n.t('dashboard_credentials-disabled')}
                                data-toggle='tooltip'
                                data-placement='top'
                              >
                                {disabled}
                              </span>
                            </h4>
                          </div>
                        </td>
                      </tr>
                      <NxCredentialsRow
                        activeKey={activeKey === key}
                        provider={key}
                        type={type}
                        hidden={activeKey !== key}
                        onToggleActive={() => setActiveKey('')}
                        updateStatus={handlerGerCredentialsInfo}
                      />
                    </Fragment>
                  )
                  )}
                </tbody>
              </table>
            </div>
          ))
        )}

        {/* MODAL */}
        <Modal isOpen={showModal} toggle={toggleModal} className='modal-lg overview-modal'>
          <ModalHeader toggle={toggleModal}>
            <a
              href='https://assets.nixi1.dkv.es/info/190828_AGV_Gu%C3%ADa_para_solicitar_acceso_a_proveedores.pdf'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i className='fa fa-file-pdf-o' />
            </a>
          </ModalHeader>
          <ModalBody>
            <object
              width='100%'
              height='600'
              data='https://assets.nixi1.dkv.es/info/190828_AGV_Gu%C3%ADa_para_solicitar_acceso_a_proveedores.pdf'
            >
              <p>Your web browser does not have a PDF plugin.</p>
            </object>
          </ModalBody>
        </Modal>
        {/* ECOMMERCE MODALS */}
        <CreatedEcommerceModal
          isOpen={isOkEcommerce}
          toggle={() => finishCreatingEcommerce()}
        />
        <ErrorEcommerceModal
          isOpen={isInvalidCredential}
          toggle={() => finishCreatingEcommerce()}
        />
      </Container>
    </div>
  )
}

export default connect((state) => ({ company: state.companies }), null)(CredentialsManagement)
